import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { toast } from 'react-toastify';
import { FlattenedExamSession } from '../types/exam-types';
import {
  SectionHeader,
  SectionWrapper,
  EmptyState,
  sessionTypeTemplate,
  sessionDateTemplate,
  timeTemplate,
  locationTemplate,
  getSessionTypeLabel,
} from './componenets/exam-shared-components';

interface UpcomingExamsProps {
  sessions: FlattenedExamSession[];
}

export const UpcomingExams: React.FC<UpcomingExamsProps> = ({ sessions }) => {
  const handleCancelRegistration = (session: FlattenedExamSession) => {
    toast.info(
      `ביטלת את ההרשמה למבחן "${session.examName}" - ${getSessionTypeLabel(session.sessionType)}`,
    );
  };

  const cancelRegistrationTemplate = (session: FlattenedExamSession) => {
    return (
      <Button
        label="ביטול הרשמה"
        icon="pi pi-times"
        size="small"
        severity="danger"
        outlined
        onClick={() => handleCancelRegistration(session)}
      />
    );
  };

  return (
    <SectionWrapper>
      <SectionHeader
        title="המבחנים הקרובים"
        icon="pi pi-clock"
        count={sessions.length}
        accentColor="#3B82F6"
      />
      <div style={{ padding: '16px' }}>
        {sessions.length > 0 ? (
          <DataTable
            value={sessions}
            stripedRows
            showGridlines
            tableStyle={{ minWidth: '50rem' }}
          >
            <Column
              field="examName"
              header="שם המבחן"
              style={{ textAlign: 'right', fontWeight: 'bold' }}
            />
            <Column
              field="courseName"
              header="קורס"
              style={{ textAlign: 'right' }}
            />
            <Column
              header="מועד"
              body={sessionTypeTemplate}
              style={{ textAlign: 'right' }}
            />
            <Column
              header="תאריך"
              body={sessionDateTemplate}
              style={{ textAlign: 'right' }}
            />
            <Column
              header="שעות"
              body={timeTemplate}
              style={{ textAlign: 'right' }}
            />

            <Column
              header="מיקום"
              body={locationTemplate}
              style={{ textAlign: 'right' }}
            />
            <Column
              header="פעולות"
              body={cancelRegistrationTemplate}
              style={{ textAlign: 'center', width: '150px' }}
            />
          </DataTable>
        ) : (
          <EmptyState message="אין מבחנים קרובים" />
        )}
      </div>
    </SectionWrapper>
  );
};
